import { id } from '@/types/index';
import { Map } from 'immutable';

import {
  SET_NUMBER_OF_TEAM_MEMBERS,
  SET_LOADING,
  PATCH_STATUS,
  UPDATE_STATUS,
  ACTIVATE_ACCOUNT,
  SET_ACCOUNT_STATS,
  PATCH_USER_STATUS,
  START_EDIT_USER,
  FINISH_EDIT_USER,
  PATCH_USER,
  START_CHANGE_USER_PASSWORD,
  CANCEL_CHANGE_USER_PASSWORD,
  CHANGE_USER_PASSWORD,
  CANCEL_PATCH_USER_STATUS,
} from '@/Pages/Account/constants';

import { IAccount, IAccountStats } from '@/types/account';

export function activateAccount() {
  return {
    type: ACTIVATE_ACCOUNT,
  };
}

export function patchStatus(status: number) {
  return {
    type: PATCH_STATUS,
    status,
  };
}

export function updateStatus(account: IAccount) {
  return {
    type: UPDATE_STATUS,
    account,
  };
}

export function setNumberOfTeamMembers(numberOfTeamMembers: number) {
  return {
    type: SET_NUMBER_OF_TEAM_MEMBERS,
    numberOfTeamMembers,
  };
}
export function startLoading() {
  return {
    type: SET_LOADING,
    isLoading: true,
  };
}

export function stopLoading() {
  return {
    type: SET_LOADING,
    isLoading: false,
  };
}


export function setAccountStats(stats: IAccountStats) {
  return {
    type: SET_ACCOUNT_STATS,
    stats,
  };
}

export function patchUserStatus(userId: id, status: number) {
  return {
    type: PATCH_USER_STATUS,
    userId,
    status,
  };
}

export function cancelPatchUserStatus() {
  return {
    type: CANCEL_PATCH_USER_STATUS,
  };
}

export function startEditUser() {
  return {
    type: START_EDIT_USER,
  };
}

export function finishEditUser() {
  return {
    type: FINISH_EDIT_USER,
  };
}

export function patchUser(userId: id, data: any) {
  return {
    type: PATCH_USER,
    userId,
    data,
  };
}

export function startChangeUserPassword() {
  return {
    type: START_CHANGE_USER_PASSWORD,
  };
}

export function cancelChangeUserPassword() {
  return {
    type: CANCEL_CHANGE_USER_PASSWORD,
  };
}

export function changeUserPassword(userId: string, data: Map<any, any>) {
  return {
    type: CHANGE_USER_PASSWORD,
    userId,
    data,
  };
}
